import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'filter',
    standalone: false
})
export class FilterPipe implements PipeTransform {
    transform(items: any[], searchText: string): any[] {
        if (!items) {
            return [];
        }
        if (!searchText) {
            return items;
        }
        searchText = searchText.toLowerCase();
        return items.filter(item => this.matchesSearch(item, searchText));
    }

    private matchesSearch(item: any, searchText: string): boolean {
        if (typeof item === 'string') {
            return item.toLowerCase().includes(searchText);
        }
        if (typeof item === 'number') {
            return item.toString().includes(searchText);
        }
        if (typeof item === 'object' && item !== null) {
            return Object.values(item).some(val => {
                if (val === null || val === undefined) {
                    return false;
                }
                if (typeof val === 'object') {
                    return this.matchesSearch(val, searchText);
                }
                return String(val).toLowerCase().includes(searchText);
            });
        }
        return false;
    }
}
